import { Fragment, useEffect, useState } from "react"
import { CompletedTickIcon, TwoFactorAuthIcon } from "../../../../components/Common/SvgIcons"
import CommonInputField from "../support/CommonInputField";
import form_messages from "../../../../constants/form_messages";
import form_input_patterns from "../../../../constants/form_input_patterns";
import { useFormik } from "formik";
import * as Yup from "yup"
import { Modal, ModalBody } from "reactstrap";
import CrossIcon from '../../../../assets/images/lystfacelogos/CrossIcon.svg'
import VerifylinkResendLayout from "../../../../components/Lystface/Helper/Verification/VerifylinkResendLayout";
import { useDispatch, useSelector } from "react-redux";
import { isNotNullOrUndefined, maskPhoneNumber } from "../../../../common/functions";
import { resendOtp, resetResendOtpResponseMsg, toggleTwoFactorAuth, verifyCurrentPassword } from "../../../../store/menu/application/actions";
import { CustomToast } from "../../../../components/Lystface/Common/CustomToast";
import Secure from "../../../../constants/secure/Secure";



const TwoFactorAuthentication = () => {
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const [isEnabled, setIsEnabled] = useState(false);
    const selectAccountSetting = useSelector(state => state.Application?.getAccountData?.data);
    const { cid, cmp_phone_code, phone, is_phone_verified, two_factor, cmp_email } = selectAccountSetting
    const ApplicationState = useSelector(state => state.Application)
    const { verifyCurrentPswd: { loading: currentPasswordLoading, error: currentPasswordError, responseMessage: currentPasswordResponseMessage } } = ApplicationState
    const { twoFactorAuth: { loading: twoFactorLoading, error: twoFactorError, responseMessage: twoFactorResponseMessage } } = ApplicationState
    const { resendOtp: { loading: sendOtpLoading, error: sendOtpError, responseMessage: senndOtpResponseMessage } } = ApplicationState


    const dispatch = useDispatch();

    useEffect(() => {
        if (isNotNullOrUndefined(senndOtpResponseMessage)) {
            CustomToast({
                message: senndOtpResponseMessage,
                status: sendOtpError ? 'failure' : "success",
                closeToast: () => {
                    console.log('Toast closed');
                },
            })
            dispatch(resetResendOtpResponseMsg())
            setPopupDetails({ ...popupDetails, onclicksetup: false, verify: false })

        }
    }, [senndOtpResponseMessage])


    useEffect(() => {
        if (isNotNullOrUndefined(currentPasswordResponseMessage) || isNotNullOrUndefined(twoFactorResponseMessage)) {
            if (currentPasswordResponseMessage ? popupDetails?.from === "disable-two-factor-auth" ? currentPasswordError : true : true) {
                CustomToast({
                    message: currentPasswordResponseMessage ? currentPasswordResponseMessage : twoFactorResponseMessage,
                    status: currentPasswordError || twoFactorError ? 'failure' : "success",
                    closeToast: () => {
                        console.log('Toast closed');
                    },
                })
                if (isNotNullOrUndefined(twoFactorResponseMessage) && !twoFactorError) {
                    handleClose();
                }
                dispatch(resetResendOtpResponseMsg())

            }
            else {
                dispatch(resetResendOtpResponseMsg())

            }

        }
    }, [currentPasswordResponseMessage, twoFactorResponseMessage])

    useEffect(() => {
        if ((!sendOtpError && isNotNullOrUndefined(senndOtpResponseMessage)) && (popupDetails.open ? popupDetails.open : popupDetails.verify)) {
            setPopupDetails({
                open: true,
                from: "two-factor-auth",
                title: "Two factor authentication",
                subtitle: <div>We've sent an OTP to the number ending with {cmp_phone_code} {maskPhoneNumber(phone)}. Please enter it below.</div>,
                checkboxContent: false,
                isLogo: false,
                buttonText: "Enable"
            })
        }

    }, [sendOtpError])


    useEffect(() => {
        if (!currentPasswordError && isNotNullOrUndefined(currentPasswordResponseMessage) && popupDetails.from === "disable-two-factor-auth") {
            twoFactoruthApi(false)
        }

    }, [currentPasswordError])

    const twoFactoruthApi = (enabled) => {
        dispatch(toggleTwoFactorAuth({ factor: enabled }))

    }

    useEffect(() => {
        setIsEnabled(two_factor)
    }, [two_factor])


    const validationType = useFormik({
        enableReinitialize: true,
        initialValues: {
            currentPwd: "",
        },
        validationSchema: Yup.object().shape({
            email: Yup.string()
                .test("email", form_messages.Signup.email.Invalid, function (value) {
                    let emailRegex
                    if (process.env.REACT_APP_NODE !== "prod") {
                        emailRegex = form_input_patterns.TESTING_EMAIL

                    }
                    else {
                        emailRegex = form_input_patterns.EMAIL

                    }
                    return emailRegex.test(value)
                })
                .max(255)
                .required(form_messages.Signup.businessemail.Required),
            pwd: Yup.string().required(form_messages.Signup.password.Required),
        }),

    })

    const handleConfirmDisabled = (validationType) => {
        dispatch(verifyCurrentPassword({ email: cmp_email, pwd: Secure.Encrypt(validationType.values.currentPwd) }))


    }

    const handleDisableTFA = () => {

        setPopupDetails({
            open: true,
            type: "danger",
            from: "disable-two-factor-auth",
            key: "currentPwd",
            titleText: "Verifying it’s you",
            bodyText: "Please enter your password to disable two-factor authentication. This action will reduce your account’s security.",
            primaryButtonText: 'Cancel', secondaryButtonText: 'Confirm disable', handleClickSecondaryButton: handleConfirmDisabled, handleClickPrimaryButton: handleClose, handleClose: handleClose
        })
    }

    const onClickSetup = () => {
        const payload = {
            login: false,
            cmp_phone_code: cid,
            cmp_phone: phone,

        }
        dispatch(resendOtp(payload, "send"))
        setPopupDetails({ verify: true, onclicksetup: true })

    }

    const handleClose = () => {
        setPopupDetails({ open: false })
        validationType.resetForm()

    }

    const toggleSwitch = () => {
        if (isEnabled) {
            setPopupDetails({
                open: true,
                from: "confirmation",
                titleText: "Disable two factor authentication",
                type: "danger",
                bodyText: <div className="two-factor-auth"><p>Disabling two-factor authentication will remove an extra layer of security from your account, making it more vulnerable to unauthorized access.</p><p className="confirm">Are you sure you want to proceed?</p></div>,
                primaryButtonText: 'Cancel', secondaryButtonText: 'Disable anyway', handleClickSecondaryButton: handleDisableTFA, handleClickPrimaryButton: handleClose, handleClose: handleClose
            })
        }
        else {
            // setIsEnabled(!isEnabled)
            twoFactoruthApi(true)
        }
    }
    return (
        <Fragment>
            <div className='singleLineCard two-factor'>
                <div className="card-header-container">
                    <div className='flexData'>
                        {TwoFactorAuthIcon}
                        <div className='heading'>Two factor authentication</div>
                    </div>

                    <div className={`manage-button`}>
                        {
                            !is_phone_verified &&
                            <button
                                onClick={onClickSetup}
                                disabled={sendOtpLoading && popupDetails?.verify && popupDetails?.onclicksetup}
                                className={`${sendOtpLoading && popupDetails?.verify && popupDetails?.onclicksetup ? "disabled" : ""}`}
                            >Setup
                                {
                                    sendOtpLoading && popupDetails?.verify && popupDetails?.onclicksetup &&
                                    <div className="spinner-container spinner-border">
                                    </div>
                                }

                            </button>
                        }


                    </div>
                </div>

                {
                    is_phone_verified &&
                    <>
                        <div className="line-break" />

                        <div className="two-factor-status-container">
                            <div className="phone-details-container">
                                <span className="heading">Text message</span>
                                <span className="subheading">Use your mobile phone to receive security code.</span>
                                <div className="verfied-status">
                                    <div className="status">
                                        <div>{CompletedTickIcon}</div>
                                        <span>Verified</span>
                                    </div>
                                    <div>{cmp_phone_code} {maskPhoneNumber(phone)}</div>
                                </div>


                            </div>
                            <div className="toggle-container">
                                <div className="toggle-status">
                                    <span>{isEnabled ? 'Enabled' : 'Disabled'}</span>
                                </div>
                                <label className="switch">
                                    <input type="checkbox" checked={isEnabled} onClick={toggleSwitch} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </>
                }


            </div>
            {
                popupDetails.open &&

                <Modal isOpen={popupDetails.open} className="popup-container settings-modal" >

                    {
                        popupDetails.from === "two-factor-auth" ?
                            <VerifylinkResendLayout title={popupDetails.title} isLogo={popupDetails.isLogo} message={popupDetails.subtitle} checkboxContent={popupDetails.checkboxContent} from={popupDetails.from} buttonText={popupDetails.buttonText} handleClose={handleClose} email={cmp_email} cmp_phone_code={cid} phone={phone} />
                            :
                            <>
                                {popupDetails.titleText &&
                                    <div className="modal-header">
                                        <div className="title">{popupDetails.titleText}</div>
                                        {handleClose && <div className="close-icon" onClick={handleClose}><img src={CrossIcon} /></div>}
                                    </div>
                                }
                                {
                                    (popupDetails.bodyText && popupDetails.from === "confirmation") &&
                                    <ModalBody className="modal-body">
                                        <p className="body-text">{popupDetails.bodyText}</p>


                                    </ModalBody>
                                }
                                {
                                    popupDetails.from === "disable-two-factor-auth" &&
                                    <CommonInputField inputLabel="" labelText={popupDetails.bodyText} inputValue={validationType.values.currentPwd} inputKey="currentPwd" validationType={validationType} applicationStatus="edit" from="popup" />

                                }
                                <div className='save-card-btn'>
                                    <button disabled={(!validationType.values[popupDetails?.key] && popupDetails.from !== "confirmation") || twoFactorLoading || currentPasswordLoading} className={`${(!validationType.values[popupDetails?.key] && popupDetails.from !== "confirmation") || twoFactorLoading || currentPasswordLoading ? "btn-cancel  button-disabled" : "btn-cancel "} ${popupDetails?.type === "danger" ? "danger" : ""}`} type='button' onClick={() => {
                                        popupDetails.handleClickSecondaryButton(validationType);
                                    }}>{popupDetails.secondaryButtonText}
                                        {(currentPasswordLoading || (twoFactorLoading && popupDetails?.from === "disable-two-factor-auth" || popupDetails?.from === "two-factor-auth")) &&
                                            <div className="spinner-container spinner-border">
                                            </div>}
                                    </button>
                                    <button disabled={false} className="btn-save me-0" type='submit' onClick={(e) => {
                                        popupDetails.handleClickPrimaryButton(popupDetails?.from, validationType);
                                    }}>{popupDetails.primaryButtonText}

                                    </button>
                                </div>
                            </>
                    }



                </Modal>

            }
        </Fragment >
    )

}
export default TwoFactorAuthentication
